import { Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { tokens } from "@fluentui/react-components";
import { contains } from "../fable_modules/fable-library-js.4.29.0/Set.js";

export class EventTypeKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Teach", "Attend", "Deadline", "Unavailable"];
    }
}

export function EventTypeKind_$reflection() {
    return union_type("Event.EventType.EventTypeKind", [], EventTypeKind, () => [[], [], [], []]);
}

export function EventTypeKind__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Påmeldt";
        case 2:
            return "Tilgjengelig";
        case 3:
            return "Utilgjengelig";
        default:
            return "Underviser";
    }
}

/**
 * Saturated Fluent palette colour — hero background, list-row dot,
 * FullCalendar event left rail, footer legend dots, etc. These match
 * the original Calendar palette but with Teach ↔ Attend swapped.
 */
export function EventTypeKind__get_Color(this$) {
    switch (this$.tag) {
        case 1:
            return tokens.colorBrandForeground1;
        case 2:
            return tokens.colorPaletteMarigoldForeground1;
        case 3:
            return tokens.colorNeutralForeground3;
        default:
            return tokens.colorPaletteRoyalBlueForeground2;
    }
}

/**
 * Light tint surface for chip / pill / FullCalendar event backgrounds.
 */
export function EventTypeKind__get_SubtleBg(this$) {
    switch (this$.tag) {
        case 1:
            return tokens.colorBrandBackground2;
        case 2:
            return tokens.colorPaletteMarigoldBackground2;
        case 3:
            return tokens.colorNeutralBackground4;
        default:
            return tokens.colorPaletteRoyalBlueBackground2;
    }
}

/**
 * Border colour for the chip outline. Slightly darker variant than
 * `Accent` so the chip reads as a single tonal unit.
 */
export function EventTypeKind__get_BorderColor(this$) {
    switch (this$.tag) {
        case 1:
            return tokens.colorBrandForeground2;
        case 2:
            return tokens.colorPaletteMarigoldForeground2;
        case 3:
            return tokens.colorNeutralStrokeAccessible;
        default:
            return tokens.colorPaletteRoyalBlueBorderActive;
    }
}

/**
 * Fluent badge colour token (informational / brand / warning).
 */
export function EventTypeKind__get_BadgeColor(this$) {
    switch (this$.tag) {
        case 1:
            return ["color", "brand"];
        case 2:
            return ["color", "warning"];
        case 3:
            return ["color", "subtle"];
        default:
            return ["color", "informative"];
    }
}

/**
 * CSS class applied to FullCalendar events. The matching `.iip-fc-*`
 * rules in `Calendar.fs` `fcStyles` use the same Fluent palette tokens
 * as the members above, so every surface stays in sync visually.
 */
export function EventTypeKind__get_FullCalendarClass(this$) {
    switch (this$.tag) {
        case 1:
            return "iip-fc-attend";
        case 2:
            return "iip-fc-deadline";
        case 3:
            return "iip-fc-utilgjengelig";
        default:
            return "iip-fc-teach";
    }
}

/**
 * Classify an event by the current user's relationship to it.
 * Disabled events (Enabled = false) always classify as Utilgjengelig — only
 * admins receive these from the server, so the type is admin-only in practice.
 * Otherwise: teaching wins, then registered attendance ⇒ Attend, else Deadline.
 */
export function deriveEventType(currentUser, attendedIds, event) {
    if (!event.Enabled) {
        return new EventTypeKind(3, []);
    }
    else if ((event.Teacher.Id === currentUser.Id) ? true : event.SecondaryTeachers.some((st) => (st.Id === currentUser.Id))) {
        return new EventTypeKind(0, []);
    }
    else if (contains(event.Id, attendedIds)) {
        return new EventTypeKind(1, []);
    }
    else {
        return new EventTypeKind(2, []);
    }
}

//# sourceMappingURL=EventType.jsx.map
